'use client';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import type { AvatarSize, AvatarStatus } from '../Avatar.types';

import styles from './Status.module.scss';

export type StatusProps = BaseComponentProps & {
  status?: AvatarStatus;
  size?: AvatarSize;
};

const STATUS_LABELS: Record<AvatarStatus, string> = {
  online: 'En línea',
  offline: 'Desconectado',
  busy: 'Ocupado',
  away: 'Ausente',
};

export const Status = ({
  style,
  className,
  status,
  size,
  testId = 'ui-avatar-status',
}: StatusProps) => {
  return (
    <div
      style={style}
      role={status && 'img'}
      aria-label={status && STATUS_LABELS[status]}
      className={classnames(
        styles['circle'],
        size && styles[`circle--${size}`],
        status && styles[`circle--${status}`],
        className,
      )}
      data-testid={testId}
    ></div>
  );
};
